export default function Footer() {
  return (
    <footer className="bg-gray-900 text-gray-300 py-16">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <img 
              src="https://static.readdy.ai/image/0fc33fa68f46f743570ad8ba1c3172ea/14439231e0fe547618927d677bb27025.png" 
              alt="Annalogix" 
              className="h-10 w-auto mb-4"
            />
            <p className="text-sm text-gray-400 leading-relaxed">
              AI-driven workflow architecture for service-driven organizations.
            </p>
          </div>

          {/* Solutions */}
          <div>
            <h4 className="text-sm font-semibold text-white mb-4 uppercase tracking-wider">Solutions</h4>
            <ul className="space-y-3">
              <li><a href="#" className="text-sm text-gray-400 hover:text-blue-400 transition-colors cursor-pointer">Workflow Optimization</a></li>
              <li><a href="#" className="text-sm text-gray-400 hover:text-blue-400 transition-colors cursor-pointer">Intelligent Automation</a></li>
              <li><a href="#" className="text-sm text-gray-400 hover:text-blue-400 transition-colors cursor-pointer">Systems Integration</a></li>
              <li><a href="#" className="text-sm text-gray-400 hover:text-blue-400 transition-colors cursor-pointer">Decision Support</a></li>
            </ul>
          </div>

          {/* Industries */}
          <div>
            <h4 className="text-sm font-semibold text-white mb-4 uppercase tracking-wider">Industries</h4>
            <ul className="space-y-3">
              <li><a href="#" className="text-sm text-gray-400 hover:text-blue-400 transition-colors cursor-pointer">Home Services</a></li>
              <li><a href="#" className="text-sm text-gray-400 hover:text-blue-400 transition-colors cursor-pointer">Med Spa</a></li>
              <li><a href="#" className="text-sm text-gray-400 hover:text-blue-400 transition-colors cursor-pointer">Real Estate</a></li>
              <li><a href="#" className="text-sm text-gray-400 hover:text-blue-400 transition-colors cursor-pointer">Staffing & Recruiting</a></li>
              <li><a href="#" className="text-sm text-gray-400 hover:text-blue-400 transition-colors cursor-pointer">Payroll / HR / ERP</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-semibold text-white mb-4 uppercase tracking-wider">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-center text-sm text-gray-400">
                <i className="ri-mail-line mr-2"></i>
                contact@annalogix.com
              </li>
              <li className="flex items-center text-sm text-gray-400">
                <i className="ri-phone-line mr-2"></i>
                Schedule a call
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-sm text-gray-500">
              © {new Date().getFullYear()} Annalogix. All rights reserved.
            </p>
            <div className="flex items-center space-x-6 mt-4 md:mt-0">
              <a href="#" className="text-sm text-gray-500 hover:text-blue-400 transition-colors cursor-pointer">Privacy Policy</a>
              <a href="#" className="text-sm text-gray-500 hover:text-blue-400 transition-colors cursor-pointer">Terms of Service</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}